module.exports = __webpack_public_path__ + "static/media/logo_catalx_v2.255bd7ca.svg";